(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["haccp-zone-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const forms = document.querySelectorAll('[data-haccp-sku-search]');

    forms.forEach((form) => {
      if (form.dataset.initialized === 'true') return;
      form.dataset.initialized = 'true';

      const input = form.querySelector('input[type="search"]');
      const results = form.querySelector('[data-search-results]');
      const status = form.querySelector('[data-search-status]');
      let products = [];
      let requestController;
      let debounceTimer;

      const closeResults = () => {
        results.hidden = true;
        input.setAttribute('aria-expanded', 'false');
      };

      const renderResults = (items) => {
        products = items;
        results.replaceChildren();

        if (items.length === 0) {
          closeResults();
          status.textContent = form.dataset.emptyText;
          return;
        }

        items.forEach((product) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          const title = document.createElement('span');
          const arrow = document.createElement('span');

          link.className = 'haccp-zone-guide__search-result';
          link.href = product.url;
          link.setAttribute('role', 'option');

          if (product.featured_image && product.featured_image.url) {
            const image = document.createElement('img');
            image.className = 'haccp-zone-guide__search-image';
            image.src = product.featured_image.url;
            image.alt = product.featured_image.alt || '';
            image.width = 52;
            image.height = 52;
            link.appendChild(image);
          } else {
            const imagePlaceholder = document.createElement('span');
            imagePlaceholder.className = 'haccp-zone-guide__search-image';
            imagePlaceholder.setAttribute('aria-hidden', 'true');
            link.appendChild(imagePlaceholder);
          }

          title.className = 'haccp-zone-guide__search-title';
          title.textContent = product.title;
          arrow.className = 'haccp-zone-guide__search-arrow';
          arrow.textContent = '→';
          arrow.setAttribute('aria-hidden', 'true');

          link.append(title, arrow);
          item.appendChild(link);
          results.appendChild(item);
        });

        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        status.textContent = `${items.length} ${form.dataset.resultsText}`;
      };

      const search = async () => {
        const query = input.value.trim();

        if (query.length < 2) {
          products = [];
          results.replaceChildren();
          status.textContent = '';
          closeResults();
          return;
        }

        requestController?.abort();
        requestController = new AbortController();
        status.textContent = form.dataset.loadingText;

        const params = new URLSearchParams({
          q: query,
          'resources[type]': 'product',
          'resources[limit]': '6',
          'resources[options][unavailable_products]': 'last',
          'resources[options][fields]': 'title,product_type,variants.title,variants.sku',
        });

        try {
          const response = await fetch(`${form.dataset.predictiveUrl}.json?${params}`, {
            signal: requestController.signal,
          });

          if (!response.ok) throw new Error(`Search failed: ${response.status}`);

          const data = await response.json();
          renderResults(data.resources.results.products || []);
        } catch (error) {
          if (error.name === 'AbortError') return;
          products = [];
          closeResults();
          status.textContent = form.dataset.emptyText;
        }
      };

      input.addEventListener('input', () => {
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(search, 180);
      });

      input.addEventListener('focus', () => {
        if (products.length > 0) {
          results.hidden = false;
          input.setAttribute('aria-expanded', 'true');
        }
      });

      form.addEventListener('submit', (event) => {
        if (products.length === 1) {
          event.preventDefault();
          window.location.assign(products[0].url);
        }
      });

      document.addEventListener('click', (event) => {
        if (!form.contains(event.target)) closeResults();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
